import { render } from "./Handwerk.vue?vue&type=template&id=785579bb&scoped=true"
import script from "./Handwerk.vue?vue&type=script&lang=js"
export * from "./Handwerk.vue?vue&type=script&lang=js"

import "./Handwerk.vue?vue&type=style&index=0&id=785579bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785579bb"]])

export default __exports__